import { ReactNode, FunctionComponent } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import moment from 'moment';
import { lightV2Theme } from '@logz-ui/styleguide';
import { AppContent } from './AppContent';
import { GlitchPage } from './Fallback/Page';
import ILogzioStyleguideTheme from 'components/theme';

interface IAppProvider {
  name?: string;
  theme?: ILogzioStyleguideTheme['logzTheme'];
  fallback?: ReactNode;
  children: ReactNode;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      gcTime: moment.duration(1, 'minute').asMilliseconds(),
    },
  },
});

export const AppProvider: FunctionComponent<IAppProvider> = ({
  name = 'AppProvider',
  children,
  theme = lightV2Theme,
  fallback = <GlitchPage />,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContent name={name} theme={theme} fallback={fallback}>
        {children}
      </AppContent>
    </QueryClientProvider>
  );
};
